'use client';

import localFont from 'next/font/local';

interface FontsProps {
    children: React.ReactNode;
}

export const corp = localFont({
    src: [
        {
            path: '../../public/fonts/Corporate-Logo-Medium-ver3.woff2',
            weight: '500',
        },
        {
            path: '../../public/fonts/Corporate-Logo-Bold-ver3.woff2',
            weight: '700',
        },
    ],
    variable: '--font-corp',
    display: 'swap',
});

export default function Fonts({ children }: FontsProps) {
    return <div className={`${corp.variable}`}>{children}</div>;
}
